import { useCallback, useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { certificateTypesApi } from '../api/certificateTypes.api';
import { TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';
import { onClearDataSearch } from '../../../services/hookHelpers';
import { formatDataSearch } from '../../../services/helpers';
import { STATUS ,VALIDITY} from '../../../interaces/selects.interfaces';
import {useDataTable} from '../../../hooks/useDataTable'
export const useCertificateTypes = () => {
  const table = useDataTable(certificateTypesApi);
     const {
       setDataFilters,
     } = table;
  useEffect(() => {
    setDataFilters([
      {
        filter: 'active',
        value_filter: '',
        data: STATUS,
        width: 'col-span-3 max-[768px]:col-span-12',
      },
       {
        filter: 'indefiniteValidity',
        value_filter: '',
        data: VALIDITY,
        width: 'col-span-3 max-[768px]:col-span-12',
      },
    ]);
  }, []);
  //metodo para los inactivos
  const [namesInactives, setNamesINactives] = useState([]);
  const getNamesInactives = useCallback(async () => {
    try {
      const response = await certificateTypesApi.getNamesInactives();
      setNamesINactives(response);
    } catch {
      toast.error(TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  }, []);


  return {
    ...table,
    namesInactives,
    getNamesInactives
  };
};
